// export const baseURL =
//   "https://glass-test-1259664823.cos.ap-shanghai.myqcloud.com/"; //测试
export const baseURL = "https://cos.mithrasglass.com/"; //正式
